import { render, staticRenderFns } from "./CommentSeenBy.vue?vue&type=template&id=42b5545a&scoped=true"
import script from "./CommentSeenBy.vue?vue&type=script&setup=true&lang=js"
export * from "./CommentSeenBy.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CommentSeenBy.vue?vue&type=style&index=0&id=42b5545a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b5545a",
  null
  
)

export default component.exports